import { render, staticRenderFns } from "./PageFooter.vue?vue&type=template&id=4cfd08b2&scoped=true"
import script from "./PageFooter.vue?vue&type=script&lang=js"
export * from "./PageFooter.vue?vue&type=script&lang=js"
import style0 from "./PageFooter.vue?vue&type=style&index=0&id=4cfd08b2&prod&scoped=true&lang=scss"
import style1 from "./PageFooter.vue?vue&type=style&index=1&id=4cfd08b2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../shared/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cfd08b2",
  null
  
)

export default component.exports